export default __webpack_public_path__ + "cdcb05e961c747ec28a9ffa5a516a5a1.svg";